const initialState = {
  xlsData: [],
  token: null,
  refreshToken: null,
  userName: "",
  userEmail: "",
  plantName: null,
  plantLocation: null,
  accessUserPlant: false,
  water_type: null,
  ro_nf_elements_used: null,
  dataset_name: null,
  sel_train: null,
  sel_pass: null,
  sel_stage: null,
  sel_pressure_vessels: null,
  sel_element_involved: null,
  tol_num_elements: null,
  is_dupont_element: false,
  num_trains: null,
  sel_element_type: null,
  ro_nf_stages: null,
  installation_date: "",
  warranty: false,
  noOfTrains: 1,
  energyPrice: 0.1,
  acidPrice: 1,
  alkaliPrice: 2,
  waterPrice: 0.9,
  costofDownTime: 1000,
  additional_chemical_price: 0,
  acid_used_per_cip: 0.5,
  alkali_used_per_cip: 0.9,
  additional_chemical_per_cip: 0,
  acid_cip_ph: 1,
  alkali_cip_ph: 12,
  cip_solution_ph: 7,
  acid_cip_temp: 25,
  alkali_cip_temp: 25,
  cip_solution_temp: 25,
  acid_cip_duration: 10,
  alkali_cip_duration: 10,
  cip_solution_duration: 10,
  file_id: null,
  fileName: null,
  sheetName: null,
  cips: null,
  cleanData: null,
  flow: "m³/h",
  pressure: "bar",
  feed_quality: "uS/cm",
  feed_water_factor: "0.7",
  temperature: "C",
  flux: "lmh",
  permeate_quality: "uS/cm",
  feed_water_permeate_factor: "0.5",
  volume: "m³",
  currency: "USD",
  mass: "kg",
  conversion_rate: "1",
  cleaningEffectiness: null,
  fouling: null,
  predictionData: null,
  selectedValues: [],
  forecastWindow: null,
  foulingType: null,
  appLanguage: "en",
  max_feed_pressure: 8,
  max_permeate_quality: 500,
  std_warranty_period: 3,
  startup_pressure_drop: null,
  designed_permeate_flow: null,
  std_membrane_age: 7,
  max_pressure_drop: 3.5,
  min_permeate_flow: null,
  forecast_window: 7,
  analysisData: null,
  taskId: null,
  CATaskId: null, // remove this if not needed
  app: null,
  clusterPoints: 20,
  maxRelativeDistance: 3,
  medianCurvePoints: 20,
  permeateFlowDropThreshold: 15,
  pressureDropThreshold: 10,
  pressureDropThresholdAbsolute: 15,
  pressureDropThresholdType: "percentage",
  useSaltPassageChange: false,
  saltPassageIncreaseThreshold: 10,
  minDaysBetweenCIPs: 20,
  maxDaysBetweenCIPs: 180,
  cipIdentificationResolution: 5,
  minIdleDaysShutdown: 20,
  minStabilizationDaysAfterCIP: 0.042,
  maxStabilizationDaysAfterCIP: 14,
  minPointsForCleaningEffectiveness: 20,
  foulingAggressivenessFactor: 5,
  adaptPermeateFlowDropThreshold: true,
  adaptPressureDropThreshold: true,
  adaptSaltPassageThreshold: true,
  numberOfIterationsToFindOptima: 10,
  simulationImproveAccuracy: false,
  deafultStabilizationDaysAfterCIP: 10,
  failureProbabilityThreshold: 95,
  optimizationTarget: "Maximize Financial Benefits",
  cleaningEffectinessThreshold: null,
  is_dupont_element: "Yes",
  add_info: "",
  digital: "",
  plantData: [],
  plantRowData: [],
  selTrain: 1,
  companyName: "", // Added companyName to initial state
  country: "",
};
const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "STORE_ACCESS_USER_PLANT": {
      return {
        ...state,
        accessUserPlant: action.payload,
      };
    }
    case "STORE_XLS_DATA":
      return {
        ...state,
        xlsData: action.payload,
      };
    case "STORE_TOKEN":
      return {
        ...state,
        token: action.payload,
      };
    case "STORE_USERNAME":
      return {
        ...state,
        userName: action.payload,
      };
    case "STORE_USEREMAIL":
      return {
        ...state,
        userEmail: action.payload,
      };
    case "STORE_COMPANY_NAME":
      return {
        ...state,
        companyName: action.payload,
      };
    case "STORE_DIGITAL":
      return {
        ...state,
        digital: action.payload,
      };
    case "SEL_SELECTED_TRAIN":
      return {
        ...state,
        selTrain: action.payload,
      };
    case "STORE_PLANT_DATA":
      return {
        ...state,
        plantData: action.payload,
      };
    case "STORE_PLANT_ROW_DATA":
      return {
        ...state,
        plantRowData: action.payload,
      };
    case "STORE_FILE_ID":
      return {
        ...state,
        file_id: action.payload.file_id,
        fileName: action.payload.fileName,
        sheetName: action.payload.sheetName,
      };
    case "STORE_PLANT_DETAILS": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "STORE_REQUEST_STATUS":
      return {
        ...state,
        requestStatus: action.payload,
      };
    case "STORE_USERDETAILS":
      return {
        ...state,
        email: action.payload.email,
        country: action.payload.country,
        role: action.payload.role,
        industry: action.payload.industry,
      };
    case "STORE_USERROLE":
      return {
        ...state,
        userRole: action.payload,
      };
    case "STORE_CIPS": {
      return {
        ...state,
        cips: [...action.payload],
      };
    }

    case "STORE_COST_DETAILS": {
      return {
        ...state,
        ...action.payload,
      };
    }

    case "STORE_DEFAULT_DETAILS": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "STORE_SETTINGS_DEFAULTS": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "STORE_REPLACEMENT_THRESHOLD": {
      return {
        ...state,
        ...action.payload,
      };
    }

    case "STORE_CLEAN_DATA": {
      return {
        ...state,
        cleanData: action.payload.cleanData,
        cleanDate: action.payload.cleanDate,
      };
    }

    case "STORE_UNITS": {
      return {
        ...state,
        flow: action.payload.flow,
        pressure: action.payload.pressure,
        feed_quality: action.payload.feed_quality,
        permeate_quality: action.payload.permeate_quality,
        temperature: action.payload.temperature,
        flux: action.payload.flux,
        volume: action.payload.volume,
        currency: action.payload.currency,
        mass: action.payload.mass,
        conversion_rate: action.payload.conversion_rate,
        feed_water_permeate_factor: action.payload.feed_water_permeate_factor,
        feed_water_factor: action.payload.feed_water_factor,
      };
    }

    case "STORE_CLEANING_EFFECTIVNESS": {
      return {
        ...state,
        cleaningEffectiness: action.payload,
      };
    }

    case "STORE_FOULING": {
      return {
        ...state,
        fouling: action.payload,
      };
    }
    case "STORE_FOULING_TYPE": {
      return {
        ...state,
        foulingType: action.payload,
      };
    }

    case "STORE_PREDICTION_DATA": {
      return {
        ...state,
        predictionData: action.payload,
      };
    }

    case "STORE_SELECTED_VALUES": {
      return {
        ...state,
        selectedValues: action.payload,
      };
    }

    case "STORE_FORECAST_WINDOW": {
      return {
        ...state,
        forecastWindow: action.payload,
      };
    }
    case "STORE_NO_OF_TRAINS": {
      return {
        ...state,
        noOfTrains: action.payload,
      };
    }
    case "CLEAR_DATA": {
      return {
        ...initialState,
        userName: state.userName,
        token: state.token,
        app: state.app,
        userEmail: state.userEmail,
        requestStatus: state.requestStatus,
        country: state.country,
        companyName: state.companyName,
      };
    }
    case "STORE_APP_LANGUAGE": {
      return {
        ...state,
        appLanguage: action.payload,
      };
    }
    case "STORE_APP": {
      return {
        ...state,
        app: action.payload,
      };
    }
    case "STORE_ANALYSIS_DATA": {
      return {
        ...state,
        analysisData: action.payload,
      };
    }
    case "STORE_TASK_ID": {
      return {
        ...state,
        taskId: action.payload,
      };
    }
    // remove this action if not needed
    case "STORE_CA_TASK_ID": {
      return {
        ...state,
        CATaskId: action.payload,
      };
    }
    case "STORE_CLEANING_EFFECTIVNESS_THRESHOLD": {
      return {
        ...state,
        cleaningEffectinessThreshold: action.payload,
      };
    }
    case "STORE_OPTIMIZATION_TARGET": {
      return {
        ...state,
        optimizationTarget: action.payload,
      };
    }
    default:
      return state;
  }
};

export default rootReducer;
